import { Component, OnInit } from '@angular/core';
import { DocumentsEnum } from '@app/core/enums/documents.enum';
import { NewModalModule, PolicyProductIdEnum } from 'outshared-lib';
import { CommonModule } from '@angular/common';
import { WucAccordionModule, WucButtonModule, WucIconUiModule, WucLinkModule } from '@inshared/website-ui-components';

@Component({
    selector: 'ins-insurance-premium-determining-factor-bonus-malus-modal',
    templateUrl: './insurance-premium-determining-factor-bonus-malus.modal.html',
    standalone: true,
    imports: [
        CommonModule,
        NewModalModule,
        WucButtonModule,
        WucIconUiModule,
        WucAccordionModule,
        WucLinkModule,
    ],
})
export class InsurancePremiumDeterminingFactorBonusMalusModal implements OnInit {
    public productId: PolicyProductIdEnum;
    public productName: string;
    public productNameShort: string;
    public documentsEnum = DocumentsEnum;
    public productIdEnum = PolicyProductIdEnum;

    public ngOnInit(): void {
        this.setProductName();
    }

    public setProductName(): void {
        if (this.productId === PolicyProductIdEnum.Car) {
            this.productName = 'autoverzekering';
            this.productNameShort = 'auto';
        }
        if (this.productId === PolicyProductIdEnum.Motorcycle) {
            this.productName = 'motorverzekering';
            this.productNameShort = 'motor';
        }
        if (this.productId === PolicyProductIdEnum.Moped) {
            this.productName = 'brommerverzekering';
            this.productNameShort = 'brommer';
        }
    }
}
